import { cancelOpenDockWarehouseAppointment } from './cancelOpenDockWarehouseAppointment'
import { deleteOpenDockWarehouseAppointment } from './deleteOpenDockWarehouseAppointment'

export type OpenDockCancelOrResetOption = 'cancel' | 'reset'

export type OpenDockCancelDialogMutationParams = {
  option: OpenDockCancelOrResetOption
  shipmentUUID: string
  stopIndex: number
}

export type OpenDockCancelDialogMutationFactoryDeps = {
  cancel: typeof cancelOpenDockWarehouseAppointment
  deleteOpenDock: typeof deleteOpenDockWarehouseAppointment
}

export function openDockCancelDialogMutationFactory({
  cancel,
  deleteOpenDock,
}: OpenDockCancelDialogMutationFactoryDeps) {
  return async function submit(
    params: OpenDockCancelDialogMutationParams,
    config?: { signal?: AbortSignal }
  ) {
    const { option, shipmentUUID, stopIndex } = params
    const stopParams = { shipmentUUID, stopIndex }
    if (option === 'reset') {
      return await deleteOpenDock(stopParams, config)
    }
    return await cancel(stopParams, config)
  }
}

const runOpenDockCancelDialogMutation = openDockCancelDialogMutationFactory({
  cancel: cancelOpenDockWarehouseAppointment,
  deleteOpenDock: deleteOpenDockWarehouseAppointment,
})

export function openDockCancelFromDialog(
  params: OpenDockCancelDialogMutationParams,
  config?: { signal?: AbortSignal }
) {
  return runOpenDockCancelDialogMutation(params, config)
}
